import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

/** Mirrors the reminder preview: a summary line, then recipient rows. */
export const ReviewReminderDialogSkeleton: FC = () => (
  <Box>
    <Skeleton variant="text" width="60%" sx={{ mb: 1.5 }} />
    {Array.from({ length: 4 }).map((_, i) => (
      // oxlint-disable-next-line react/no-array-index-key
      <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1, mb: '1px' }}>
        <Skeleton variant="circular" width={32} height={32} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="40%" />
          <Skeleton variant="text" width="25%" />
        </Box>
      </Box>
    ))}
    <Skeleton variant="rectangular" height={88} sx={{ mt: 2, borderRadius: 1 }} />
  </Box>
);
